import React, { Component } from 'react';

import HeroSection from '../components/HeroSection';
import CloudinaryImage from '../components/CloudinaryImage';

class Photo extends Component {
  render() {
    return (
      <main>
        <HeroSection
            imageSrc="https://res.cloudinary.com/dpoz8quj5/image/upload/v1510329998/carl-cox-2017_1600w_mdotxw.jpg"
            imagePosX="center"
            h1="Peter Liu" h2="Photography">
        </HeroSection>
        <section className="flex-section photography">
          <h1>Music</h1>
          <CloudinaryImage img="v1510402419/rza_ed2gee.jpg"></CloudinaryImage>
          <CloudinaryImage img="v1510402420/richiehawtin_peterliu_kbz4gc.jpg"></CloudinaryImage>
          <CloudinaryImage img="v1510402419/factoryfloor-rbma-peterliu_ndug9b.jpg"></CloudinaryImage>
          <CloudinaryImage img="v1510403962/undergroundstage_o3tpqt.jpg"></CloudinaryImage>
          <CloudinaryImage img="v1510402419/adambeyer-main-crowd-peterliu_np7bro.jpg"></CloudinaryImage>
          <CloudinaryImage img="v1510402419/carlcraig-vizensemble-main-peterliu_dl43ti.jpg"></CloudinaryImage>
          <CloudinaryImage img="v1510402419/grandma-techno_qdscyw.jpg"></CloudinaryImage>
          <p>Published in: Dancing Astronaut, WKDU Philadelphia 91.7FM</p>
        </section>
        <section className="flex-section photography">
          <h1>Travel</h1>
          <CloudinaryImage img="v1510429087/shasta_oydnnt.jpg"></CloudinaryImage>
          <CloudinaryImage img="v1510413945/shastarail_ief7om.jpg"></CloudinaryImage>
          <CloudinaryImage img="v1510330785/puget_1440w_nyim9p.jpg"></CloudinaryImage>
          <CloudinaryImage img="v1510413945/goldengate_opvu5k.jpg"></CloudinaryImage>
          <CloudinaryImage img="v1510413945/spaceneedle_ljbwvs.jpg"></CloudinaryImage>
          <CloudinaryImage img="v1510413945/habana_anff7m.jpg"></CloudinaryImage>
        </section>
        <div className="photo-links">
          <p>More photos available on:</p>
          <a aria-label="500px" title="500px" href="https://500px.com/peterliu888" target="_blank" rel="noreferrer noopener">
            <i aria-hidden="true" className="fa fa-500px"></i>
          </a>
          <a aria-label="Instagram" title="Instagram" href="https://www.instagram.com/hearhearradio/" target="_blank" rel="noreferrer noopener">
            <i aria-hidden="true" className="fa fa-instagram"></i>
          </a>
        </div>
      </main>
    );
  }
}

export default Photo;



// WEBPACK FOOTER //
// ./src/views/Photo.js